export const TABS = {
  MAIN: "main",
  SUMMARIES: "summaries",
  // HELP and SETTINGS occupy the same tab position. SETTINGS replaces HELP for users
  // in the verbose_summaries feature flag. HELP will be removed once SETTINGS is fully rolled out.
  HELP: "help",
  SETTINGS: "settings",
}

export const AVAILABILITY_TIMEOUT_ERROR = "AVAILABILITY_TIMEOUT";

// Constants representing different AiMS availability and behavior statuses
export const AIMS_STATUS = {
  // AiMS is available for this meeting, both the organizer and attendees will receive the summary
  AVAILABLE: "AimsAvailable",

  // AiMS is partially available, only the organizer will receive the summary
  SUMMARY_TO_ORGANIZER: "SummaryToOrganizer",

  // AiMS is not available for this meeting (e.g., due to legal policy)
  NOT_AVAILABLE: "AimsNotAvailable",

  // The meeting has external attendee
  EXTERNAL_ATTENDEE: "ExternalAttendee",

  // AiMS failed due to an unexpected error (could be from frontend or backend)
  EXCEPTION: "AimsException",

  // AiMS timed out due to some downstream dependency taking too long (ex - availability lambda taking longer than 30 seconds)
  TIMEOUT: "AimsTimeout",

  // Transcript is available for this meeting
  TRANSCRIPT_AVAILABLE: "TranscriptAvailable",

  // Transcript is not available for this meeting
  TRANSCRIPT_NOT_AVAILABLE: "TranscriptNotAvailable",
};

export const AIMS_NOT_AVAILABLE_TITLE = "Inform attendees if needed";

export const AIMS_NOT_AVAILABLE_MESSAGE = {
  DEFAULT: "Not all meetings are approved for Amazon Meetings.",
  REGIONS: "Some attendees are from regions where Amazon Meetings isn't yet available.",
};

export const TRANSCRIPT_NOT_AVAILABLE_MESSAGE = "Some participants are from regions where transcription isn't yet available.";

export const AIMS_AVAILABILITY_MESSAGE_TYPES = {
  WORK_COUNCIL: "work_council",
  HIRE_LEO: "hire-leo",
};

// Width of the in-meeting app panel.
export const PANEL_WIDTH = "362px";

// Start / End button width on status screens.
export const STATUS_BUTTON_MIN_WIDTH = "194px";

// WaveformLayout icon circle: warning / error icons scaled from Meridian's 24px to 32px.
export const WAVEFORM_ICON_SCALE = 1.33;

export const ROLES = {
  ORGANIZER: "organizer",
  ALTERNATIVE_HOST: "alternativeHost",
  ATTENDEE: "attendee",
};

export const SUMMARIZE_STATES = {
  DEFAULT: 'default',           // Ready to summarization
  LOADING: 'loading',           // Starting/stopping summarization
  SUMMARIZING: 'summarizing',   // Currently summarizing
  REJECTED: 'rejected',         // Someone else is starting
  STOPPED: 'stopped',           // Summarization stopped
  READY: 'ready'                // Summary is ready
};

export const TRANSCRIPTION_STATES = {
  DEFAULT: 'default',           // Ready to transcription
  LOADING: 'loading',           // Starting/stopping transcription
  TRANSCRIBING: 'transcribing', // Currently transcribing
  REJECTED: 'rejected',         // Someone else is starting
  STOPPED: 'stopped',           // Transcription stopped
};

export const OUTLOOK_WARNINGS = {
  MULTI_MEETING_FOUND_FROM_OUTLOOK: "MultiMeetingFoundFromOutlook",
  MEETING_NOT_FOUND_FROM_OUTLOOK: "MeetingNotFoundFromOutlook"
};

export const RTMS_REQUESTER_DEFAULT_NAME = "Meeting organizer";

// Context constants for modals and components
export const MAIN_CONTEXT = {
  SUMMARIZE: "summarize",
  TRANSCRIBE: "transcribe",
};

// SessionStorage keys for summary pagination
export const SESSION_STORAGE_KEYS = {
  SUMMARY_CACHE: "summaryCache",
  LAST_EVALUATED_KEY: "lastEvaluatedKey",
  RAW_SUMMARIES: "rawSummaries",
  IS_END_OF_DATA: "isEndOfData",
};

// Feature flags
export const FEATURE_FLAGS = {
  ALLOW_SUMMARY_DISTRIBUTION_TOGGLE: true, // Disabled pending legal review on allowing organizers to restrict summary distribution
};

// Autostart modes for transcription
export const AUTO_START_MODES = {
  SINGLE: "single",
  MULTIPLE: "multiple",
};

export const VERBOSITY_LEVELS = {
  CONCISE: "concise",
  MODERATE: "moderate",
  DETAILED: "detailed",
};

// --- Feedback / prompt / Whos Who constants (merged from components/common/constants.jsx) ---

export const FEEDBACK_PAGE = {
    SUMMARIZE_END: "summarizeEnd",
    IN_MEETING_FEEDBACK_TAB: "inMeetingFeedbackTab", 
    IN_CLIENT_FEEDBACK_TAB: "inClientFeedbackTab"
}

export const FEEDBACK = {
    THUMBS_UP: "ThumbsUp",
    THUMBS_DOWN: "ThumbsDown"
};

// PhoneTool profile page for an Amazon alias; append the alias.
export const PHONE_TOOL_USER_BASE = "https://phonetool.amazon.com/users/";


// --- Summary classification constants (merged from components/common/summary/constants.jsx) ---

export const SUMMARY_FEEDBACK_STATUS = {
  APPROVED: 'approved',
  NOT_APPROVED: 'not_approved',
  OTHER: 'other'
}

export const SUMMARY_TYPES = {
  APPROVED: ["low_risk"],
  NOT_APPROVED: ["performance_review", "hr_complaint", "investigation", "interview"],
};

// In-session content tabs (the primary UI's session view). Distinct from TABS above,
// which is the legacy nav.
export const SESSION_TABS = {
  ASSISTANT: "assistant",
  AGENDA: "agenda",
  ACTION_ITEMS: "actionItems",
};

// View states for the main container
export const VIEWS = {
  MAIN: "main",
  SUMMARIES: "summaries",
  SUMMARY_DETAIL: "summaryDetail",
  SETTINGS: "settings",
};


// Built-in agent — always present, always enabled, not part of the extensions platform.
export const BUILT_IN_AGENT = {
  id: "amazon-meetings",
  name: "Amazon Meetings Assistant",
  shortName: "ama",
};

// Shown as a toast when saving a user preference (auto-start or summary detail
// level) fails — i.e. the /preferences update did not return HTTP 200.
export const PREFERENCE_SAVE_ERROR_MESSAGE =
  "Couldn't save your changes right now. Try again in a moment.";

// Box fill radius large enough to fully round a pill-shaped badge at any height.
export const PILL_RADIUS_FILL = 999;
